import Reflux from 'reflux';

const ClusterTrafficActions = Reflux.createActions({
  traffic: { asyncResult: true },
});

export default ClusterTrafficActions;



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/graylog-project-cli-release/.repos/graylog2-server/graylog2-web-interface/src/actions/cluster/ClusterTrafficActions.js